// extracted by mini-css-extract-plugin
export default {"spin":"TjTp4Tnz9kZgBadl_nw5"};